import * as Factory from 'factory.ts'

import { type BillApprovalChainApiModel } from '../BillApprovalChainApiModel'

export const BillApprovalChainApiModelStub =
  Factory.Sync.makeFactory<BillApprovalChainApiModel>({
    id: Factory.each((i) => i + 1),
    name: Factory.each((i) => `Approval chain ${i + 1}`),
  })
